import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { hasCookieConsent } from "../utils/cookieConsent";
import { COOKIE_POLICY_VERSION } from "../constants/legal";

const LegalFooterBar = () => {
  const [cookieBannerVisible, setCookieBannerVisible] = useState(
    () => !hasCookieConsent(COOKIE_POLICY_VERSION),
  );

  useEffect(() => {
    const onChange = () =>
      setCookieBannerVisible(!hasCookieConsent(COOKIE_POLICY_VERSION));
    window.addEventListener("cookie-consent-changed", onChange);
    return () =>
      window.removeEventListener("cookie-consent-changed", onChange);
  }, []);

  return (
    <div
      className={`fixed inset-x-0 z-[80] flex items-center justify-center gap-4 border-t border-gray-200 bg-white/95 px-4 py-1.5 text-xs text-gray-500 backdrop-blur-sm ${
        cookieBannerVisible ? "bottom-12" : "bottom-0"
      }`}
    >
      <Link
        to="/politica-privacidad"
        className="hover:text-gray-800 hover:underline"
      >
        Política de Privacidad
      </Link>
      <span>·</span>
      <Link
        to="/tratamiento-datos"
        className="hover:text-gray-800 hover:underline"
      >
        Tratamiento de Datos
      </Link>
      <span>·</span>
      <Link
        to="/politica-privacidad#cookies"
        className="hover:text-gray-800 hover:underline"
      >
        Cookies
      </Link>
    </div>
  );
};

export default LegalFooterBar;
